RivalIQ.apps.Favorites.module('views', function (views, App, Backbone, Marionette, $, _, sortable) {

    'use strict';

    const DEFAULT_MAX_METRICS = 8;

    function shouldShowCustomSummary(view) {
        const widget = view.dashboardModel.getWidget();
        return (widget && widget.getProp('showCustomSummary')) || false;
    }

    function shouldShowSummaryCalculation(view) {
        const widget = view.dashboardModel.getWidget();
        return (widget && widget.getProp('primaryDimension') === 'companySetId') || false;
    }

    views.MetricsView = Marionette.CompositeView.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        template: '#favoritesBuilderMetricsTemplate',
        childViewContainer: '.metric-builder-rows',

        // Include source picker
        source: true,
        // Include TAM picker
        timeAnalysisMode: true,

        ui: {
            add: '.x-add',
            popovers: '[data-toggle="popover"]'
        },

        events: {
            'click .x-add': 'onAddClick'
        },

        behaviors: {
            Localizable: {}
        },

        initialize: function () {
            const me = this;
            Marionette.bindEntityEvents(me, me.dashboardModel.getWidget(), {
                'change:showCustomSummary': 'onShowCustomSummaryChanged',
                'change:primaryDimension': 'onPrimaryDimensionChanged',
                'change:columnWidth': 'setAddVisibility'
            });
        },

        templateHelpers: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget();
            const summaryRowName = (widget && widget.isLandscapeAggregateWidget ? 'Calculation' : 'Summary Row');

            return {
                hideLabel: Boolean(me.getOption('hideLabel')),
                metricOnly: !me.getOption('source') && !me.getOption('timeAnalysisMode') && !me.getOption('showProgressBar'),
                showProgressBar: me.getOption('showProgressBar'),
                showSparklineOption: true,

                // showCustomSummary we get from props instead of view options because its value changes outside of this view hierarchy.
                showCustomSummary: shouldShowCustomSummary(me),
                shouldShowSummaryCalculation: shouldShowSummaryCalculation(me),

                summaryRowName: summaryRowName
            };
        },

        childView: views.Metric,
        childViewOptions: function () {
            const me = this;
            return {
                dashboardModel: me.options.dashboardModel,
                source: me.getOption('source'),
                timeAnalysisMode: me.getOption('timeAnalysisMode'),
                useFuzzyMetricFind: me.getOption('useFuzzyMetricFind'),
                showProgressBar: me.getOption('showProgressBar'),
                disableOptgroups: me.getOption('disableOptgroups'),
                additionalMetrics: me.getOption('additionalMetrics'),
                showCustomSummary: shouldShowCustomSummary(me),
                shouldShowSummaryCalculation: shouldShowSummaryCalculation(me)
            };
        },

        onAddClick: function () {
            const me = this;

            // clone the last valid metric.
            const dashboardModel = me.getOption('dashboardModel');
            const validChannels = me.collection.getValidChannels(dashboardModel.getWidget());
            const validMetrics = me.collection.filter(function (metric) {
                return Boolean(validChannels.get(metric.getSource()));
            });
            const newMetric = _.last(validMetrics).clone();
            if (me.getOption('useEmptyMetricOnAdd')) {
                const metric = newMetric.get('metric');
                if (metric) {
                    newMetric.set({
                        metric: {}
                    });
                }
            }

            me.collection.add(newMetric);
        },

        setAddVisibility: function () {
            const me = this;

            const dashboardModel = me.getOption('dashboardModel');
            const maxMetrics = _.result(dashboardModel.getWidget(), ['maxMetrics']) || DEFAULT_MAX_METRICS;
            const visible = me.collection.length < maxMetrics;
            me.ui.add.toggleClass('hide', !visible);
        },

        onShowCustomSummaryChanged: function () {
            const me = this;

            me.render();
            me.initializePopovers();
        },

        onPrimaryDimensionChanged: function () {
            const me = this;

            me.render();
            me.initializePopovers();
        },

        onAttach: function () {
            const me = this;

            if (!me.isDestroyed) {
                sortable(me.$childViewContainer)[0].addEventListener('sortupdate', function (e) {
                    // see https://github.com/lukasoppermann/html5sortable#sortupdate
                    me.onSortUpdate();
                });
                me.setAddVisibility();
                me.initializePopovers();
            }
        },

        onAddChild: function () {
            const me = this;
            me.refreshSortable();
            me.setAddVisibility();
        },

        onRemoveChild: function () {
            const me = this;
            me.refreshSortable();
            me.setAddVisibility();
        },

        refreshSortable: function () {
            const me = this;
            if (!me.$childViewContainer) {
                return;
            }
            sortable(me.$childViewContainer);
        },

        onSortUpdate: function () {
            const me = this;
            const collection = me.collection;

            const order = _.map(me.$childViewContainer.find('[data-id]'), function (el) {
                return $(el).data('id');
            });

            collection.comparator = function (a, b) {
                return order.indexOf(a.cid) - order.indexOf(b.cid);
            };

            collection.sort();

            delete collection.comparator;

            me.refreshSortable();

            // re-register the sortable as it seems to get unset after a sort update.
            sortable(me.$childViewContainer)[0].addEventListener('sortupdate', function (e) {
                // see https://github.com/lukasoppermann/html5sortable#sortupdate
                me.onSortUpdate();
            });
        },

        initializePopovers: function () {
            const me = this;
            me.ui.popovers.popover({
                html: true,
                trigger: 'hover',
                placement: 'auto',
                container: 'body'
            });
        }
    });
}, window.sortable);
